import React, { useState, useEffect, useContext } from 'react';
import { AddBox, Reorder } from '@mui/icons-material';
import { Backdrop, CircularProgress } from '@mui/material';
import { ModalGeneral, Tabla, VisorPDF } from 'ui-component';
import headers from './components/headers';
import LayautContext from 'Context/ContextLayaut';
import AvisoConfirmacion from 'ui-component/AvisoConfirmacion';
import { ServiciosCurso, ModalCostosGrupo } from './components';
import FormActividad from './components/FormActividad';
import ModalPreguntasActividad from './components/ModalPreguntasActividad';
import FormDetalleActividad from './components/FormDetalleActividad';
import FormOrdenar from './components/FormOrdenar';
import FormDependenciaDetalle from './components/FormDependenciaDetalle';
import VistaEnlace from './components/VistaEnlace';

const DetalleActividad = ({ permisos, actividad, onCambioNivel }) => {
    //
    const context = useContext(LayautContext);
    const serviciosCursos = ServiciosCurso();

    const [detalleActividad, setDetalleActividad] = useState([]);
    const [ctl, setCtl] = useState({ estatusCurso: [] });
    const [confirm, setConfirm] = useState({ open: false });
    const [modal, setModal] = useState({ open: false, titulo: '' });
    const [cargando, setCargando] = useState({ open: false });
    // Función helper para completar el progreso al 100%
    const completarProgreso = () => {
        // Simular progreso de 90% a 100% durante la inserción
        let progreso = 90;
        const interval = setInterval(() => {
            progreso += 2;
            if (progreso <= 100) {
                context.mensaje({
                    open: false // Hack para acceder al setProgresoCarga
                });
                // Necesitamos exponer setProgresoCarga en el context
            } else {
                clearInterval(interval);
            }
        }, 200);
    };
    // Handle
    const actualizarData = (nuevaCurso = []) => {
        const datausuario = detalleActividad.map((oc) => oc.idDetalleActividad);
        nuevaCurso.forEach((detalleActividadI) => {
            const indice = datausuario.indexOf(detalleActividadI.idDetalleActividad);
            if (indice >= 0) detalleActividad.splice(indice, 1, detalleActividadI);
            else detalleActividad.splice(0, 0, detalleActividadI);
        });
        setDetalleActividad([...detalleActividad]);
    };

    const actualizarDataV2 = (arr) => {
        let nuevoDato = arr[0];
        let arrActual = detalleActividad;

        let indexActual = arrActual.findIndex((x) => x.idDetalleActividad == nuevoDato.idDetalleActividad);

        if (indexActual != -1) {
            arrActual[indexActual] = nuevoDato;
            setDetalleActividad([...arrActual]);
        }
    };

    const quitaData = (nuevoDato) => {
        let arrActual = detalleActividad;

        let indexActual = arrActual.findIndex((x) => x.idDetalleActividad == nuevoDato.idDetalleActividad);

        if (indexActual != -1) {
            arrActual.splice(indexActual, 1);
            setDetalleActividad([...arrActual]);
        }
    };

    const abrirNuevoMaterial = () => () => {
        context.formulario.abrir({
            open: true,
            width: 'md',
            titulo: `Nuevo material para la actividad "${actividad.titulo}"`,
            propsForm: { data: null, ctl: ctl },
            formulario: FormDetalleActividad,
            aceptar: (dataForm) => {
                const dataFormPivote = { ...dataForm };
                const formData = new FormData();
                if (dataFormPivote.archivo && dataFormPivote?.archivo?.length > 0) {
                    dataFormPivote.archivo = dataFormPivote.archivo[0].file;
                    const tipoArchivo = dataFormPivote.archivo.type;
                    if (tipoArchivo.search('video/') >= 0) dataFormPivote.idTipoActividad = 2;
                    else if (tipoArchivo == 'application/pdf') dataFormPivote.idTipoActividad = 4;
                    else if (tipoArchivo.search('image/') >= 0) dataFormPivote.idTipoActividad = 5;
                    else if (tipoArchivo.startsWith('audio/')) {
                        dataFormPivote.idTipoActividad = 8;
                    } else dataFormPivote.idTipoActividad = 6;
                }
                Object.keys(dataFormPivote).forEach((key) => formData.append(key, dataFormPivote[key]));
                formData.append('idActividad', actividad.idActividad);
                formData.append('orden', detalleActividad.length + 1);

                if (dataFormPivote?.archivo?.size > 1900000) {
                    const nombreOriginal = dataFormPivote.archivo.path;
                    formData.delete('archivo');
                    context.formulario.cerrar();
                    serviciosCursos.chunkFile(
                        (res, uidFolderName) => {
                            formData.append('archivo', uidFolderName + '/' + nombreOriginal);
                            formData.append('uidFolderName', uidFolderName);
                            serviciosCursos.insertDetalleActividad(
                                (res) => {
                                    setDetalleActividad(res.detalleActividad);
                                    // CERRAR TODO AL FINALIZAR INSERCIÓN
                                    context.mensaje({ open: false }); // Cerrar mensaje automático
                                },
                                formData,
                                {
                                    cargando: true, // MANTENER CARGANDO ACTIVO
                                    isBigFileResponse: true,
                                    uidFolderName: uidFolderName,
                                    hideSuccessMessage: true // Flag para no mostrar mensaje aún
                                }
                            );
                        },
                        {},
                        dataFormPivote.archivo
                    );
                } else {
                    serviciosCursos.insertDetalleActividad(
                        (res) => {
                            setDetalleActividad(res.detalleActividad);
                            context.formulario.cerrar();
                        },
                        formData,
                        {
                            headers: {
                                'content-type': 'multipart/form-data'
                            }
                        }
                    );
                }
            }
        });
    };
    const abrirOrdenar = () => () => {
        context.formulario.abrir({
            open: true,
            width: 'sm',
            titulo: 'Ordenar Materiales',
            propsForm: { data: { dataOrden: detalleActividad }, ctl: ctl },
            formulario: FormOrdenar,
            aceptar: (dataForm) => {
                if (dataForm.dataOrdenada == undefined) return context.mensaje({ open: true, value: 'No se ha hacho ningun orden' });
                serviciosCursos.updateOrdenMaterial(
                    (res) => {
                        setDetalleActividad(res.detalleActividad);
                        context.formulario.cerrar();
                    },
                    { ...dataForm, idActividad: actividad.idActividad }
                );
                return true;
            }
        });
    };
    const abrirEditarActividadDetalle = (detalleActividad, isVer) => {
        context.formulario.abrir({
            open: true,
            width: 'md',
            isVer: isVer == 1,
            titulo: `${isVer ? '' : 'Editar'} ${detalleActividad.titulo} para la actvidad ${actividad.titulo}`,
            propsForm: {
                data: detalleActividad,
                ctl: ctl,
                isVer
            },
            formulario: FormDetalleActividad,
            aceptar: (dataForm) => {
                const dataFormPivote = { ...dataForm };
                const formData = new FormData();
                if (dataFormPivote.archivo && dataFormPivote.archivo[0] && !dataFormPivote.archivoActivo) {
                    dataFormPivote.archivo = dataFormPivote.archivo[0].file;
                    const tipoArchivo = dataFormPivote.archivo.type;
                    if (tipoArchivo.search('video/') >= 0) dataFormPivote.idTipoActividad = 2;
                    else if (tipoArchivo == 'application/pdf') dataFormPivote.idTipoActividad = 4;
                    else if (tipoArchivo.search('image/') >= 0) dataFormPivote.idTipoActividad = 5;
                    else if (tipoArchivo.startsWith('audio/')) {
                        dataFormPivote.idTipoActividad = 8;
                    } else dataFormPivote.idTipoActividad = 6;
                }
                formData.append('idActividad', actividad.idActividad);
                formData.append('idDetalleActividad', detalleActividad.idDetalleActividad);
                Object.keys(dataFormPivote).map((key) => formData.append(key, dataFormPivote[key]));

                if (dataFormPivote?.archivo?.size > 1900000 && !dataFormPivote.archivoActivo) {
                    const nombreOriginal = dataFormPivote.archivo.path;
                    formData.delete('archivo');
                    context.formulario.cerrar();
                    serviciosCursos.chunkFile(
                        (res, uidFolderName) => {
                            formData.append('archivo', uidFolderName + '/' + nombreOriginal);
                            formData.append('uidFolderName', uidFolderName);
                            serviciosCursos.updateActivivdadDetalle(
                                (res) => {
                                    actualizarDataV2(res.detalleActividad);
                                    // CERRAR MENSAJE AUTOMÁTICO
                                    context.mensaje({ open: false });
                                },
                                formData,
                                {
                                    cargando: true, // CAMBIAR A true PARA MANTENER UI BLOQUEADA
                                    isBigFileResponse: true,
                                    uidFolderName: uidFolderName,
                                    hideSuccessMessage: true // AGREGAR FLAG
                                }
                            );
                        },
                        {},
                        dataFormPivote.archivo
                    );
                } else {
                    serviciosCursos.updateActivivdadDetalle(
                        (res) => {
                            actualizarDataV2(res.detalleActividad);
                            context.formulario.cerrar();
                        },
                        formData,
                        {
                            headers: {
                                'content-type': 'multipart/form-data'
                            }
                        }
                    );
                }
            }
        });
    };
    const descargarArchivo = (data) => {
        window.open(data?.linkVideo, '_blank', 'noreferrer');
    };
    const traerDatosExtra = (detalleActividad, isVer = 0) => {
        if (['1', '2', '4', '5', '6', '8', '9'].includes(detalleActividad.idTipoActividad))
            serviciosCursos.getactividadDetalleExtra(
                (extra) => {
                    if (detalleActividad.idTipoActividad == 4 && isVer) {
                        setModal({
                            open: true,
                            formulario: VisorPDF,
                            titulo: 'PDF actividad: ' + detalleActividad?.titulo,
                            propsModal: {
                                isBase64: true,
                                data: { ...detalleActividad, ...extra },
                                title: 'PDF actividad: ' + detalleActividad?.titulo
                            }
                        });
                    } else if (detalleActividad.idTipoActividad == 6 && isVer) {
                        descargarArchivo({ ...detalleActividad, ...extra });
                    } else if (detalleActividad.idTipoActividad == 9 && isVer) {
                        // Enlace en modo ver - mostrar vista previa
                        setModal({
                            open: true,
                            formulario: VistaEnlace,
                            titulo: 'Vista previa: ' + detalleActividad?.titulo,
                            propsModal: {
                                data: { ...detalleActividad, ...extra }
                            }
                        });
                    } else {
                        // Modo edición
                        abrirEditarActividadDetalle({ ...detalleActividad, ...extra }, isVer);
                    }
                },
                { idDetalleActividad: detalleActividad.idDetalleActividad }
            );
        else abrirEditarActividadDetalle(detalleActividad, isVer);
    };
    const abrirEliminarCambio = (detalleActividad) => {
        let texto = `¿Estás seguro de eliminar el material ${detalleActividad.titulo}? No será considerada al tomar el curso.`;
        let status = -1;

        setConfirm({
            open: true,
            text: texto,
            aceptar: () => {
                setCargando({ open: true });

                serviciosCursos.cambiarEstatusActividadDetatalle(
                    (nuevaData) => {
                        const detalle = nuevaData.detalleActividad;
                        quitaData(detalle[0]);
                        setCargando({ open: false });

                        setConfirm({ open: false });
                    },
                    { idDetalleActividad: detalleActividad.idDetalleActividad, estatus: status, idActividad: actividad.idActividad }
                );
            }
        });
    };

    const abrirConfirmarCambio = (detalleActividad) => () => {
        let texto = `¿Estás seguro de volver a activar el material ${detalleActividad.titulo}?`;
        let status = 1;
        if (detalleActividad.estatus === '1') {
            texto = `¿Estás seguro de desactivar el material ${detalleActividad.titulo}? No será considerada al tomar el curso.`;
            status = 0;
        }
        setConfirm({
            open: true,
            text: texto,
            aceptar: () =>
                serviciosCursos.cambiarEstatusActividadDetatalle(
                    (nuevaData) => {
                        actualizarDataV2(nuevaData.detalleActividad);
                        setConfirm({ open: false });
                    },
                    { idDetalleActividad: detalleActividad.idDetalleActividad, estatus: status, idActividad: actividad.idActividad }
                )
        });
    };
    const abrirPreguntas = (detalleActividad) => {
        serviciosCursos.getActividadPregunta(
            (res) =>
                setModal({
                    open: true,
                    titulo:
                        detalleActividad.idTipoActividad == 3 || detalleActividad.idTipoActividad == 10
                            ? `Preguntas del examen "${detalleActividad.titulo}"`
                            : `Preguntas de la encuesta "${detalleActividad.titulo}"`,
                    formulario: ModalPreguntasActividad,
                    propsModal: {
                        permisos: permisos,
                        detalleActividad: { ...detalleActividad, preguntas: res.preguntas }
                    }
                }),
            { idDetalleActividad: detalleActividad.idDetalleActividad }
        );
    };
    const cerrarModalCurso = () => setModal({ ...detalleActividad, open: false });

    const guardarDependencia = (dependenciaSelected, regSelected) => (event) => {
        const dataSend = {
            dataSelected: dependenciaSelected,
            idActividad: actividad.idActividad,
            idDetalleActividad: regSelected.idDetalleActividad
        };
        serviciosCursos.guardarDependenciaDetalle((res) => {
            setDetalleActividad(res.detalleActividad);
            cerrarModalCurso();
        }, dataSend);
    };

    const openFormDependencia = (selected) => {
        setModal({
            open: true,
            titulo: 'Agregar dependencias',
            formulario: FormDependenciaDetalle,
            propsModal: {
                data: {
                    selected: selected,
                    allData: detalleActividad.filter((det) => det.idDetalleActividad != selected.idDetalleActividad),
                    columnKey: 'idDetalleActividad'
                },
                headers: headers(() => {}, { estatusCurso: null }, null).detalleActividad,
                guardarDependencia: guardarDependencia,
                cerrar: cerrarModalCurso
            }
        });
    };

    // Config
    const acciones = [
        { label: 'Nuevo material', icon: <AddBox />, click: abrirNuevoMaterial, disabled: !permisos.crear },
        { label: 'Ordenar material', icon: <Reorder />, click: abrirOrdenar, disabled: !permisos.editar }
    ];
    const accionesFila = [
        { label: 'Editar', onClick: (data) => traerDatosExtra(data), enabled: (row) => row.estatus == '1' && permisos.editarActividad },
        {
            label: 'Ver',
            onClick: (data) => traerDatosExtra(data, 1),
            enabled: (row) => ['1', '2', '4', '5', '6', '8', '9'].includes(row.idTipoActividad) && permisos.ver
        },
        { label: 'Dependencia', onClick: openFormDependencia, enabled: (row) => row.estatus == '1' && permisos.editar },
        { label: 'Ver Preguntas', onClick: abrirPreguntas, enabled: (row) => ['3', '7', '10', '11'].includes(row.idTipoActividad) },
        { label: 'Eliminar', onClick: abrirEliminarCambio, enabled: true },
        { label: 'Sin opciones', onClick: () => {}, enabled: (row) => row.estatus == 0 && row.idTipoActividad == 1 && !permisos.ver }
    ];
    useEffect(() => {
        if (actividad)
            serviciosCursos.getDetalleActividad(
                (ct) => {
                    setDetalleActividad(ct?.detalleActividad || []);
                    setCtl({ ...ctl, tiposActividad: ct?.tiposActividad || [] });
                },
                { idActividad: actividad.idActividad }
            );
        else setDetalleActividad([]);
    }, [actividad]);
    return (
        <>
            <Tabla
                rows={detalleActividad}
                columns={headers(abrirConfirmarCambio, ctl, permisos).detalleActividad}
                accionesTabla={acciones}
                accionesFila={accionesFila}
                columnKey="idDetalleActividad"
            />
            <AvisoConfirmacion
                open={confirm.open}
                title="Advertencia"
                text={confirm.text}
                accept={confirm.aceptar}
                cancel={() => setConfirm({ open: false })}
            />
            <ModalGeneral open={modal.open} width="md" titulo={modal.titulo} OnCerrar={cerrarModalCurso}>
                {modal.formulario && <modal.formulario {...modal.propsModal} />}
            </ModalGeneral>

            <Backdrop open={cargando.open}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
};

export default DetalleActividad;
